import { useCallback } from 'react';

import { t as translate } from '@/utils/i18n';

/**
 * Hook to access translations
 * @example
 * const { t } = useTranslations();
 * <Button>{t('common.buttons.next')}</Button>
 */
export const useTranslations = (namespace?: string) => {
  const t = useCallback(
    (key: string, params?: Record<string, string | number>) => {
      const fullKey = namespace ? `${namespace}.${key}` : key;
      return translate(fullKey as Parameters<typeof translate>[0], params);
    },
    [namespace]
  );

  return { t };
};
